var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.tagsView.hasNavBar)?[_c('keep-alive',{attrs:{"include":_vm.$store.getters.cachedViews}},[_c('router-view')],1)]:[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }